// Tiny module-level registry for resolving a media id → a downloadable URL.
//
// The shared incoming-messages hook (`useIncomingMessages.ts`) needs to turn a
// peer-profile `avatarMediaId` into a URL it can persist on the conversation
// row, but it must stay platform-agnostic — it can't import the apps/web media
// client directly. Each host registers its own resolver post-bootstrap (web:
// `fetchMediaDownloadUrl`; desktop: its equivalent). Mirrors the
// `registerCurrentUserAccountId` registry pattern.

type MediaUrlResolver = (mediaId: string) => Promise<string | undefined>;

let resolver: MediaUrlResolver | null = null;

/** Host registers (or clears, with `null`) its media-id → URL resolver. */
export function registerMediaUrlResolver(fn: MediaUrlResolver | null): void {
  resolver = fn;
}

/**
 * Resolve a media id to a downloadable URL using the host-registered resolver.
 * Returns `undefined` when no resolver is registered or the lookup fails — the
 * caller treats that as "no avatar" rather than an error.
 */
export async function resolveMediaUrl(mediaId: string): Promise<string | undefined> {
  if (resolver === null) return undefined;
  try {
    return await resolver(mediaId);
  } catch {
    return undefined;
  }
}
